import styled from 'styled-components';
import { colors } from '../../assets/variables';

export const Box = styled.div<{ open: boolean }>`
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: ${({ open }) => (open ? '#f5f9ff' : '#fff')};

  transition:
    background-color 250ms ease,
    border-color 250ms ease,
    box-shadow 250ms ease;

  &:hover {
    background: ${({ open }) => (open ? '#f5f9ff' : '#fafafa')};
    border-color: #d0d7de;
  }
  ${({ open }) =>
    open &&
    `
      border-color: #4f8cff;
      box-shadow: 0 4px 12px rgba(79, 140, 255, 0.15);
    `}
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .top {
    border-bottom: 1px solid #e6e6e6;
    padding: 16px 16px;
    display: flex;
    align-items: center;
  }
  .title {
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-left: 8px;
    div {
      &:first-child {
        color: ${colors.primary};
        font-weight: 600;
      }
      &:last-child {
        font-size: 14px;
        color: #626262;
        text-transform: capitalize;
      }
    }
  }
  .content {
    padding: 16px 16px;
    min-height: 80px;
    flex: 1;
    .item {
      display: flex;
      align-items: flex-start;
      justify-content: center;
      margin-bottom: 8px;
    }
  }
  .bottom {
    padding: 16px 16px;
    display: flex;
    justify-content: flex-end;
    margin-top: auto;
  }
  .button-delete {
    padding: 14px;
    font-size: 13px;
    background: white;

    color: ${colors.primary};
    border: 1px solid ${colors.primary};
    &:hover {
      background: ${colors.action};
      color: ${colors.primary};
    }
  }
`;
const ButtonWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  button {
    margin: 0 8px;
    min-width: 120px;
    &.delete-yes {
      background-color: ${colors.action};
      color: ${colors.primary};
      border: 1px solid ${colors.action};

      &:hover {
        background-color: ${colors.baseLight};
        color: ${colors.primary};
        border: 1px solid ${colors.primary};
      }
    }
  }
`;
const TopBtnWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .back-button {
    min-width: 100px;
    background: white;
    border: 1px solid ${colors.primary};
    color: ${colors.primary};
  }
`;
export const AccordionContent = styled.div<{ open: boolean }>`
  overflow: hidden;
  max-height: ${({ open }) => (open ? '100%' : '0')};
  opacity: ${({ open }) => (open ? 1 : 0)};

  padding: ${({ open }) => (open ? '24px' : '0 24px')};

  transition:
    max-height 300ms ease-in-out,
    opacity 200ms ease-in-out,
    padding 300ms ease-in-out;
`;
const Toggle = styled.div<{ checked: boolean }>`
  width: 48px;
  height: 28px;
  border-radius: 999px;
  cursor: pointer;
  position: relative;

  background: ${({ checked }) => (checked ? '#4f8cff' : '#d9d9d9')};

  transition: background-color 250ms ease;

  &:after {
    content: '';
    position: absolute;
    top: 3px;
    left: ${({ checked }) => (checked ? '23px' : '3px')};

    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: white;

    transition: left 250ms ease;
  }
`;
const ToggleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }
`;
const SummaryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 16px;
  margin-bottom: 12px;

  border: 1px solid #d6e4f2;
  border-radius: 8px;

  background: #fff;

  transition: all 0.2s ease;

  &:hover {
    background: #f4f4f4;
  }
`;
const SubmitButtonWrap = styled.div`
  margin-top: 24px;
  padding-top: 16px;
  display: flex;
  justify-content: flex-end;
`;
export default {
  Box,
  ButtonWrap,
  TopBtnWrap,
  AccordionContent,
  Toggle,
  ToggleRow,
  SummaryItem,
  SubmitButtonWrap,
};
